import { ElementType } from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import Render from 'components/render';
import Popover from 'containers/Popover';
import { PlayIcon, PlayIconLg } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import Space from 'UIKit/Space';

import styles from './videoTutorial.module.scss';

interface PlayVideoTutorialProps {
  onPlay: () => void;
  showTooltip?: boolean;
  hideTitle?: boolean;
  testId: string;
  metaData: {
    video?: string;
    title: string;
    thumbnail: string;
    duration?: string;
  };
  customClassName?: string;
  textClassName?: string;
  icon: ElementType;
}

/**
 * Video Tutorial with thumbnail
 */
const PlayVideoTutorialWithThumb = ({
  onPlay,
  showTooltip,
  hideTitle,
  testId = 'playVideoTutorialButton',
  metaData,
  customClassName,
  textClassName,
  icon: IconComponent,
}: PlayVideoTutorialProps) => {
  const { t } = useTranslation(['common']);

  const { title, thumbnail, duration } = metaData;

  return (
    (<Box
      data-testid={testId}
      className={cx(styles.playIconWrapper, customClassName)}
      onClick={onPlay}
      role="button"
      tabIndex={0}
    >
      {showTooltip ? (
        // @ts-ignore
        (<Popover body={t('common:play_video')}>
          {/* @ts-ignore */}
          <PlayIcon className={styles.playIconTutorial} />
        </Popover>)
      ) : (
        <Box relative className={styles.imgContainer}>
          {/* @ts-ignore */}
          {IconComponent ? (
            <IconComponent className={styles.playIconTutorial} />
          ) : (
            <PlayIconLg className={styles.playIconTutorial} />
          )}
          <img src={thumbnail} title={title} alt={title} width={150} height={83} />
          <div className={styles.gradientOverlay} />
        </Box>
      )}
      <Space
        direction="vertical"
        className={cx(styles.videoText, textClassName, {
          'd-none': hideTitle,
        })}
      >
        <p>{title}</p>
        <Render when={duration}>
          <p>{duration}</p>
        </Render>
      </Space>
    </Box>)
  );
};

export default PlayVideoTutorialWithThumb;
